/* import __COLOCATED_TEMPLATE__ from './sq-file-select-link.hbs'; */
import Component from '@ember/component';

/**
`SqFileSelectLink` allows you to create a fake "link" that, when
clicked, opens a browser default file select window, then sets
the value of the component to the first file selected.

This component does not currently support multiple file selecting,
but could probably easily be altered to do so.

This component WILL NOT WORK without associated CSS, currently located at
`app/assets/stylesheets/bridgeport/components/_file-select-link.sass`

```handlebars
{{sq-file-select-link value=csvFile linkText=(t "your.key")}}
```
*/
// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  fileTypeWhitelist: null,
  classNames: ['file-select-link'],
  disabled: false,
  actions: {
    fileInputChanged(e) {
      // The `e.files` fallback is only here for testing, as `target` is readonly
      // checking event.originalEvent for the file is necessary for events triggered by jQuery
      let files;
      if (e.target && e.target.files && e.target.files.length > 0) {
        files = e.target.files;
      } else if (e.originalEvent && e.originalEvent.files && e.originalEvent.files.length > 0) {
        files = e.originalEvent.files;
      } else {
        files = e.files;
      }
      const file = files && files[0];
      if (file) {
        this.set('value', file);
        if (this.fileChanged) {
          this.fileChanged(e, file);
        }
      }
    }
  }
});